import React from 'react'

import { Box, Button, Card, Heading, Inline, Modal, Stack, Text } from '@myxplor/stardust'

interface Props {
  isOpen: boolean
  service: Papi.Service
  onCancel(): void
}

const TabletLoginModal = ({ isOpen, service, onCancel }: Props) => {
  return (
    <Modal backdrop isOpen={isOpen} onBlur={onCancel}>
      <Card>
        <Box minWidth={600} padding="small">
          <Stack space="small">
            <Heading level={5}>Tablet Password Reset</Heading>
            <Text>A password reset email has been sent to {service.contact_email}</Text>
            <Inline align="right" space="small">
              <Button variant="outline" onClick={onCancel}>
                Confirm
              </Button>
            </Inline>
          </Stack>
        </Box>
      </Card>
    </Modal>
  )
}

export default React.memo(TabletLoginModal)
